import { Injectable } from '@angular/core';
import { MessageNotificationService } from 'message-notification-service-lib';
import { ISignatureConsentService } from '../../../interfaces/isignatureproviderservice';

@Injectable({ providedIn: 'root' })
export class DocusignConsentService implements ISignatureConsentService {
  constructor(private messageNotificationService: MessageNotificationService) {}

  requestConsent(consentUrl: string): void {
    const top = window.screenLeft + (window.outerWidth - 470) / 2;
    const left = window.screenTop + (window.outerHeight - 500) / 2;
    const consentWindow = window.open(consentUrl, '_blank', `location=no,toolbar=no,width=470,height=500,top=${top},left=${left}`);

    if (!consentWindow) {
      console.error('Failed to launch Docusign consent window.');
      return;
    }

    const intervalId = setInterval(() => {
      if (consentWindow.closed) {
        console.log('Consent window closed.');
        window.removeEventListener('message', listener);
        window.clearInterval(intervalId);
      }
    }, 500);

    const listener = (e: MessageEvent) => {
      console.log('event', e);
      if (e.data) {
        consentWindow.close();
        window.clearInterval(intervalId);
        window.removeEventListener('message', listener);

        if (e.data.docusignError) {
          const msg = e.data.docusignErrorMessage ?? 'Application consent failed.';
          this.messageNotificationService.error(msg);
        } else if (e.data.responseUrl) {
          // responseUrl is just http://localhost:4200/?code=<code>
          this.messageNotificationService.info('Thank you for providing consent.');
        }
      }
    };

    window.addEventListener('message', listener);
  }
}
